export async function saveTexture(URL, token, data, file) {
    return data.id
        ? updateTexture(URL, token, data, file)
        : createTexture(URL, token, data, file);
}

export async function createTexture(URL, token, data, file) {
    try {
        const json = JSON.stringify(data);
        const blob = new Blob([json], {
            type: "application/json",
        });
        const formData = new FormData();
        formData.append("data", blob);
        formData.append("image", file);
        const response = await fetch(URL, {
            method: "POST",
            headers: {
                Authorization: `Bearer ${token}`,
            },
            body: formData,
        });
        if (response.ok) {
            return {
                success: true,
                res: await response.json(),
            };
        } else {
            return {
                success: false,
                status: response.status,
            };
        }
    } catch (err) {
        return {
            success: false,
            message: err.message,
        };
    }
}

async function updateTexture(URL, token, data, file) {
    try {
        const json = JSON.stringify(data);
        const blob = new Blob([json], {
            type: "application/json",
        });
        const formData = new FormData();
        formData.append("data", blob);
        formData.append("image", file);
        const response = await fetch(URL, {
            method: "PUT",
            headers: {
                Authorization: `Bearer ${token}`,
            },
            body: formData,
        });
        if (response.ok) {
            return {
                success: true,
                res: await response.json(),
            };
        } else {
            return {
                success: false,
                status: response.status,
            };
        }
    } catch (err) {
        return {
            success: false,
            message: err.message,
        };
    }
}

export async function getTextureById(URL, token) {
    try {
        const response = await fetch(URL, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
        });
        if (response.ok) {
            return {
                success: true,
                data: await response.json(),
            };
        } else {
            return {
                success: false,
                status: response.status,
            };
        }
    } catch (err) {
        return {
            success: false,
            message: err.message,
        };
    }
}

export async function deleteTextureById(URL, token) {
    try {
        const response = await fetch(URL, {
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
        });
        console.log(response);
        if (response.ok) {
            return {
                success: true,
                message: "DELETED",
            };
        } else {
            return {
                success: false,
                status: response.status,
                body: await response.json()
            };
        }
    } catch (err) {
        return {
            success: false,
            message: err.message,
        };
    }
}

export async function fetchDataTexture(URL, token, data) {
    try {
        const response = await fetch(URL, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(data),
        });
        if (response.ok) {
            return {
                success: true,
                data: await response.json(),
            };
        } else {
            return {
                success: false,
                status: response.status,
            };
        }
    } catch (err) {
        return {
            success: false,
            message: err.message,
        };
    }
}
